import type { Route } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { SettingsResolver } from '@resolvers/settings.resolver';
import { IsLoggedInGuard } from '@guards/is-loggedin.guard';
import { NotFoundComponent } from '@features/not-found/not-found.component';
import { appChildrenRoutes } from './app.children.routes';

export const appRoutes: Route[] = [
  {
    path: 'health',
    children: [],
  },
  {
    path: '',
    canActivate: [IsLoggedInGuard],
    component: LayoutComponent,
    resolve: {
      settings: SettingsResolver,
    },
    children: appChildrenRoutes,
  },
  {
    path: '**',
    component: NotFoundComponent,
  },
];
